module.exports = __webpack_public_path__ + "img/handover_transporter.bc7ccb7c.jpg";